import { Slide } from 'pure-react-carousel';
import React from 'react';
import s from './slideStyles';
import Slide4 from './slide_4.svg';

export default ({ index }) => (
    <Slide className={s.slideWrapper} index={index}>
        <div className={s.imageWrapper}>
            <Slide4 />
        </div>
        <div className={s.textWrapper}>
            <p>
                All the virtual experts can be paired and put together to handle
                your specific requirements be it tasks, processes or expertise.
            </p>
            <p>
                <em>Everything fully documented and transparent.</em>
            </p>
        </div>
    </Slide>
);



// WEBPACK FOOTER //
// ./src/components/sections/ourVirtualExperts/steps/slides/slide4.component.js